import { createI18n } from 'vue-i18n'
import zh from './locales/zh'
import en from './locales/en'

const messages = {
  zh,
  en
}

const i18n = createI18n({
  legacy: false,
  // 优先使用 'locale'，如果没有则使用 'language'（兼容旧代码）
  locale: localStorage.getItem('locale') || localStorage.getItem('language') || 'zh',
  fallbackLocale: 'zh',
  messages,
  globalInjection: true
})

export default i18n 